import { Card, CardContent, FormControl, FormControlLabel, Grid, Radio, RadioGroup, Typography } from '@material-ui/core'
import React from 'react'
import { useRecoilState, useSetRecoilState } from 'recoil'
import { choicesState, loadingState, predictionState, whenAnsweredState } from '../atoms'
import { predict } from '../utils'


const TIPIQuestion = props => {
    const [choices, setChoices] = useRecoilState(choicesState)
    const [predictions, setPredictions] = useRecoilState(predictionState)
    const [whenAnswered, setWhenAnswered] = useRecoilState(whenAnsweredState)
    const setLoading = useSetRecoilState(loadingState)
    const handleChange = async event => {
        setLoading(true)
        let tenPersonalItemInventoryChoices = [...choices.tenPersonalItemInventory]
        if (tenPersonalItemInventoryChoices[props.id] === 0) {
            let whenAnsweredtenPersonalItemInventoryPredictions = [...whenAnswered.tenPersonalItemInventory]
            whenAnsweredtenPersonalItemInventoryPredictions[props.id] = predictions.tenPersonalItemInventory[props.id]
            setWhenAnswered({
                activities: whenAnswered.activities,
                tenPersonalItemInventory: whenAnsweredtenPersonalItemInventoryPredictions,
                wordDefinitions: whenAnswered.wordDefinitions
            })
        }
        tenPersonalItemInventoryChoices[props.id] = Number(event.target.value)
        setChoices({
            activities: choices.activities,
            tenPersonalItemInventory: tenPersonalItemInventoryChoices,
            wordDefinitions: choices.wordDefinitions
        })
        const [activitiesPrediction, tenPersonalItemInventoryPrediction, wordDefinitionsPrediction] = await predict(choices.activities, tenPersonalItemInventoryChoices, choices.wordDefinitions)
        setPredictions({
            activities: activitiesPrediction,
            tenPersonalItemInventory: tenPersonalItemInventoryPrediction,
            wordDefinitions: wordDefinitionsPrediction
        })
        setLoading(false)
    }
    const predictionText = () => {
        let prediction = predictions.tenPersonalItemInventory[props.id] * 7
        if (whenAnswered.tenPersonalItemInventory[props.id] !== 0)
            prediction = whenAnswered.tenPersonalItemInventory[props.id] * 7
        let text = String(prediction)
        switch (Math.round(prediction)) {
            case 1:
                text += " (Disagree strongly)"
                break;
            case 2:
                text += " (Disagree moderately)"
                break;
            case 3:
                text += " (Disagree a little)"
                break;
            case 4:
                text += " (Neither agree nor disagree)"
                break;
            case 5:
                text += " (Agree a little)"
                break;
            case 6:
                text += " (Agree moderately)"
                break;
            case 7:
                text += " (Agree strongly)"
                break;
            default:
                break;
        }
        return text
    }
    return (
        <Card variant='elevation' style={{ marginTop: '20px' }}>
            <CardContent>
                <Typography>
                    {props.id + 1} - {props.question}
                </Typography>
                <Grid container>
                    <Grid xs={6} item>
                        <FormControl component='fieldset'>
                            <RadioGroup value={String(choices.tenPersonalItemInventory[props.id])} onChange={handleChange}>
                                <FormControlLabel value="0" control={<Radio />} label="Unselected" />
                                <FormControlLabel value="1" control={<Radio />} label="1- Disagree strongly" />
                                <FormControlLabel value="2" control={<Radio />} label="2- Disagree moderately" />
                                <FormControlLabel value="3" control={<Radio />} label="3- Disagree a little" />
                                <FormControlLabel value="4" control={<Radio />} label="4- Neither agree nor disagree" />
                                <FormControlLabel value="5" control={<Radio />} label="5- Agree a little" />
                                <FormControlLabel value="6" control={<Radio />} label="6- Agree moderately" />
                                <FormControlLabel value="7" control={<Radio />} label="7- Agree strongly" />
                            </RadioGroup>
                        </FormControl>
                    </Grid>
                    <Grid xs={6} item style={{ textAlign: 'center', alignSelf: 'center' }}>
                        <Typography style={{ color: 'red', fontStyle: 'italic' }}>
                            Predicted: {predictionText()}
                        </Typography>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    )
}

export default TIPIQuestion